import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import api from './api/axiosConfig';
import './styles/App.css';

import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Login from './components/Login';
import CRMSettings from './components/CRMSettings';
import LeadForm from './components/LeadForm';
import ThankYou from './components/ThankYou';
import PrivacyPolicy from './components/PrivacyPolicy';
import ScenarioBuilder from './components/scenariobuilder';
import ScenarioList from './components/scenariolist';
import ExportLeadsButton from './components/ExportLeadsButton';

function App() {
  const [agent, setAgent] = useState(null);
  const [loadingAgent, setLoadingAgent] = useState(true);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/agent/me')
        .then(res => setAgent(res.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoadingAgent(false));
    } else {
      setLoadingAgent(false);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('token');
    setAgent(null);
  };

  const toggleDarkMode = () => setDarkMode(prev => !prev);

  if (loadingAgent) return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading…</div>;

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {!agent && (
          <>
            <Route path="/register" element={<Register onRegistered={setAgent} />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/login" element={<Login onLoggedIn={setAgent} />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}

        {/* Private Routes */}
        {agent && (
          <>
            <Route path="/dashboard" element={
              <div
                style={{
                  padding: '32px',
                  fontFamily: 'Inter, sans-serif',
                  backgroundColor: darkMode ? '#1e1e1e' : '#f5f7fa',
                  minHeight: '100vh',
                  color: darkMode ? '#ecf0f1' : '#2c3e50',
                  transition: 'all 0.4s ease'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <button
                    onClick={toggleDarkMode}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '30px',
                      border: 'none',
                      backgroundColor: darkMode ? '#f39c12' : '#34495e',
                      color: 'white',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
                  </button>
                  <button
                    onClick={logout}
                    style={{
                      padding: '10px 20px',
                      borderRadius: '30px',
                      border: '1px solid #c0392b',
                      backgroundColor: '#c0392b',
                      color: 'white',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    Logout
                  </button>
                </div>

                <h1 style={{ fontSize: '36px', textAlign: 'center', marginTop: '20px', marginBottom: '40px' }}>
                  🛠️ Client Test Dashboard
                </h1>

                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                  <CRMSettings />
                  <hr style={{ margin: '40px 0', border: '1px solid #ddd' }} />
                  <ScenarioBuilder />
                  <hr style={{ margin: '40px 0', border: '1px solid #ddd' }} />
                  <ScenarioList />
                </div>

                <ExportLeadsButton />
              </div>
            } />

            <Route path="/" element={<LeadForm agent={agent} />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
          </>
        )}
      </Routes>

      <ToastContainer
        position="top-center"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
        icon
        limit={3}
      />
    </Router>
  );
}

export default App;
